import type { FaireProductEntity } from "../../entity_types/product";

export const p_3gu6kzglmv: FaireProductEntity = {
  token: "p_3gu6kzglmv",
  type: "product",
  name: "Thank You Flower Stem Card",
  brandToken: "b_1sahwzac",
  brandName: "Hammerpress",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/0a6475269d388c577d52ef3e795bb94624a8a8a4ae6bfd7ce391d190525c0b00/1563554390.jpg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6ae121b326323ab1b808d3b9b84bc1248baaead3ca24d322f27834d09bfc2c7.jpeg",
  ],
  priceDollars: 3,
  description:
    'Folding note card with white envelope. Letterpress printed on 110lb. Recycled white paper. Blank inside.\n\nCard size: 4.25" x 5.50" (folded).\n\nPackaged in plant-based polylactic acid (PLA) certified compostable bag.\n\nDesigned and letterpress printed at our studio in Kansas City, Missouri. Made in USA.',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:19.667Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
